import { PersonaSize } from './Persona.Props';

export const SIZE_TO_PIXELS = {
    [PersonaSize.extraExtraSmall]: 24,
    [PersonaSize.size28]: 28,
    [PersonaSize.tiny]: 30,
    [PersonaSize.extraSmall]: 32,
    [PersonaSize.small]: 40,
    [PersonaSize.smallPlus]: 40,
    [PersonaSize.regular]: 48,
    [PersonaSize.regularPlus]: 64,
    [PersonaSize.large]: 72,
    [PersonaSize.extraLarge]: 100,
};
